// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".smartDynamicMenu[data-v-5f2633bc] {\n  position: relative;\n  pointer-events: none;\n}\n.smartDynamicMenu .moveable-target[data-v-5f2633bc], .smartDynamicMenu .moveable-item[data-v-5f2633bc] {\n  pointer-events: auto;\n  position: absolute !important;\n  top: 0;\n  left: 0;\n}", ""]);
// Exports
module.exports = exports;
